// @ts-strict-ignore
import styled from "styled-components";
import { Paragraph3 } from "components/parts/Typography/cryptopedia";

export const StyledInput = styled.input`
  box-sizing: border-box;
  height: 44px;
  border-radius: 10px;
  padding: 0 42px 0 16px;
  font-size: 16px;
  font-family:
    Work Sans,
    serif;
  outline: none;
  width: 100%;
  &:focus {
    ${({ error }) => !!error && "background-color: rgba(229, 0, 28, 0.05);"}
  }
  ${({ error, theme }) => {
    if (!!error) {
      return `
        border: 1px solid ${theme.borderColors.negative};
        background-color: rgba(229, 0, 28, 0.05) !important; `;
    }
    return `
        border: 1px solid ${theme.borderColors.secondary};
        background-color: ${theme.backgroundColors.primary};
    `;
  }}
`;

export const StyledLabel = styled(Paragraph3)`
  top: -42px;
  left: 0px;
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  position: absolute;
`;

export const ErrorText = styled(Paragraph3)`
  color: ${({ theme }) => theme.textColor.negative};
  margin: 8px 0 0 0;
  position: absolute;
  left: 0;
  right: 0;
`;

export const ClearButtonContainer = styled.div`
  position: absolute;
  right: 24px;
  top: 50%;
  width: 14px;
  height: 14px;
  transform: translateY(-50%);
  cursor: pointer;
  &:hover {
    path {
      stroke: #000;
    }
  }
`;
